// FIXME: Update this configuration file based on your project information
export const AppConfig = {
  site_name: 'PairCar',
  title: 'PairCar',
  description: 'PairCar',
  locale: 'en',
};
